const Auth = {
  /**
   * Authenticate a user. Save a token string in Local Storage
   *
   * @param {string} token
   */
  authenticateUser: (token) => {
    localStorage.setItem('token', token);
  },

  /**
   * Check if a user is authenticated - check if a token is saved in Local Storage
   *
   * @returns {boolean}
   */
  isUserAuthenticated: () => {
    return localStorage.getItem('user') !== null || sessionStorage.getItem('user') !== null;
  },

  /**
   * Deauthenticate a user. Remove a token from Local Storage.
   *
   */
  deauthenticateUser: () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
  },

  /**
   * Get a token value.
   *
   * @returns {string}
   */

  getToken: () => {
    return localStorage.getItem('token') || sessionStorage.getItem('token');
  }
};

export default Auth;
